import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  flex-direction: column;
  width: min-content;
  margin: auto;

  @media (max-width: ${tokens.breakpoints.s}) {
    width: 100%;
    margin: unset;
  }
`;

export default Center;
